<section class="why-choose-container">
    <div class="content">
        <h2>Why Choose YoGamez Pro?</h2>

        <p><b>Play now with purpose.</b> YoGamez Pro combines exciting gameplay, reliable performance, and community-driven experiences built for local and global players. From casual fun to competitive sessions, every feature is designed to keep you engaged, rewarded, and connected.</p>
        <button class="start-btn">START NOW</button>
    </div>
</section>
